import DefaultMap from '../../Map/DefaultMap'
import LocationMarkers from './LocationMarkers'
import { AddressFile } from './types'
import { FC } from 'react'

type LocationMapProps = {
  pickupAddress: AddressFile,
  dropoffAddress: AddressFile
}
const LocationMap: FC<LocationMapProps> = ({ pickupAddress, dropoffAddress }) => (
  <DefaultMap className="location-map">
    <LocationMarkers
      pickupAddress={pickupAddress}
      dropoffAddress={dropoffAddress} />
  </DefaultMap>
)

export default LocationMap
